import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { renderShipmentCalculated } from '../../helpers/render-shipment-calculated'

export const calculatedMaterialWeightColumn: ShipmentColumn = {
    key: 'calculatedMaterialWeight',
    dataIndex: ['calculated', 'materialWeight'],
    title: 'Вес материала',
    width: 80,
    onCell: onCellStandard,
    render: renderShipmentCalculated(
        calculated => Math.round((calculated?.materialWeight || 0) * 10) / 10
    ),
}
